export default "__VITE_ASSET___ofYol2n__"